(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Tracking = global.NewHomeSource.Tracking || {};

  class CommentsQuestionsFormTracking {
    /**
     * Initializes a new instance of the class.
     * Sets the rootNode property to null.
     */
    constructor() {
      this.rootNode = null;
    }

    /**
     * Initializes the comments questions form tracking by binding necessary events.
     * @returns {this} Returns the current instance for chaining.
     */
    initialize() {
      this.bindEvents();
      return this;
    }

    /**
     * Binds the click event listener to the node associated with this instance.
     * The click event will trigger the `onClick` handler, which is bound to the current context.
     */
    bindEvents() {
      if (!this.rootNode) {
        return;
      }
      this.buttonNode = this.getButtonNode();
      if (!this.buttonNode) {
        return;
      }
      this.onClick = this.onClick.bind(this);
      this.buttonNode.addEventListener('click', this.onClick);
    }

    /**
     * Sets the root node for the instance.
     *
     * @param {HTMLElement} rootNode - The root DOM node to be assigned.
     * @returns {this} Returns the current instance for chaining.
     */
    setRootNode(rootNode) {
      this.rootNode = rootNode;
      return this;
    }

    /**
     * Returns the DOM node for the button component.
     *
     * @returns {Element} The element with data-comments-submit-button attribute, or null if not found.
     */
    getButtonNode() {
      return this.rootNode.querySelector('[data-comments-submit-button]');
    }

    /**
     * Returns the DOM node for the comment text area component.
     *
     * @returns {Element} The element with data-comments-textarea attribute, or null if not found.
     */
    getCommentTextNode() {
      return this.rootNode.querySelector('[data-comments-textarea]');
    }

    /**
     * Handles the click event for the button component.
     * Dispatches two 'trackOnDemandEvent' events for form tracking:
     * - One for GA4, with eventName 'form_open' and parameters including button name and comment text.
     * - One for Segment, with event 'Lead Button Clicked' and parameters including button action and comment text.
     *
     * @returns {void}
     */
    onClick() {
      const buttonName = this.buttonNode ? this.buttonNode.innerText : 'Submit request';
      const commentTextNode = this.getCommentTextNode();
      const commentText = commentTextNode ? commentTextNode.value : '';
      const eventGa4 = {
        eventName: 'form_open',
        params: {
          click_target: 'right_rail_form',
          position: 'right_rail_form',
          button_name: buttonName,
          lead_form_comment: commentText,
        },
        eventType: 'GA4Event',
      };
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventGa4 }
      }));

      const eventSegment = {
        event: 'Lead Button Clicked',
        button_action: buttonName,
        lead_form_comment: commentText,
        eventType: 'segmentEvent',
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventSegment }
      }));
    }

    /**
     * Removes the click event listener from the associated DOM node.
     * Should be called to clean up resources when the instance is no longer needed.
     */
    destroy() {
      if (!this.buttonNode) {
        return;
      }
      this.buttonNode.removeEventListener('click', this.onClick);
    }
  }

  global.NewHomeSource.Tracking.CommentsQuestionsFormTracking = CommentsQuestionsFormTracking;
}(window));
